var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += 'An error has occurred: ' +
__e( error.message );

}
return __p
};

/*
original source:

An error has occurred: <%- error.message %>

*/
